/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AgentBadge_agent$ref = any;
export type JobEventActorType = "AGENT" | "DISPATCH" | "SYSTEM" | "USER" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventFinished_event$ref: FragmentReference;
export type JobEventFinished_event = {|
  +timestamp: any,
  +actor: {|
    +type: JobEventActorType
  |},
  +job: {|
    +softFailed: boolean,
    +exitStatus: ?string,
    +agent: ?{|
      +heartbeatAt: ?any,
      +$fragmentRefs: AgentBadge_agent$ref,
    |},
  |},
  +exitStatus?: number,
  +$refType: JobEventFinished_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "exitStatus",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JobEventFinished_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actor",
      "storageKey": null,
      "args": null,
      "concreteType": "JobEventActor",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "job",
      "storageKey": null,
      "args": null,
      "concreteType": "JobTypeCommand",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "softFailed",
          "args": null,
          "storageKey": null
        },
        v0,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "agent",
          "storageKey": null,
          "args": null,
          "concreteType": "Agent",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent",
              "args": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "heartbeatAt",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "type": "JobEventFinished",
      "selections": [
        v0
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fdcd5b97433af04aaefbd7e212969519';
module.exports = node;
